import type { ThemeShapeName } from './themedShapes';
export type Direction = 'UP' | 'DOWN' | 'LEFT' | 'RIGHT';
export type ChessShapeName = 'pawn' | 'rook' | 'knight' | 'bishop' | 'queen' | 'king';
export type ShapeName = 'rectangle' | 'square' | 'circle' | 'diamond' | 'cross' | 'star' | 'l-shape' | 'custom' | 'hollow' | ChessShapeName | ThemeShapeName;
export type Cell = { x: number; y: number };
export type ArrowData = { id: string; cells: Cell[]; direction: Direction };
export type Level = {
  id: string;
  number: number;
  seed: number;
  generatorVersion: number;
  shape: ShapeName;
  width: number;
  height: number;
  active: Cell[];
  arrows: ArrowData[];
  difficulty: number;
  timeLimit: number;
  introTip?: string;
};
export type Mode = 'regular' | 'daily';
export type Attempt = {
  id: string;
  mode: Mode;
  levelId: string;
  seed: number;
  generatorVersion?: number;
  remainingArrowIds: string[];
  lives: number;
  mistakes: number;
  deadline: number;
  timeLimit: number;
  reviveUsed: boolean;
  status: 'playing' | 'failed';
  startedAt: number;
  // Freeze the exact content so publishing cannot replace an in-flight puzzle.
  levelSnapshot?: Level;
  // One-time message when an incompatible old board was rebuilt for gap blocking.
  rulesUpdated?: boolean;
};
export const THEME_NAMES = ['Default', 'Gold', 'Coral', 'Teal'] as const;
export type ThemeName = typeof THEME_NAMES[number];
export type Player = {
  tutorialStatus?: 'completed' | 'skipped';
  coins: number;
  completedIds: string[];
  creditedRewards: string[];
  unlockedThemes: ThemeName[];
  theme: ThemeName;
  dailyDate: string;
  dailyAttempts: number;
  dailyCompleted: boolean;
};
/** The game's tunables, from the release's client config (see config.ts). */
export type GameConfig = {
  maxLevel: number;
  progressionOrder: number[];
  lives: number;
  startingCoins: number;
  hintCost: number;
  reviveCost: number;
  reviveSeconds: number;
  rewardByTier: number[];
  perfectBonus: number;
  firstClearBonus: number;
  dailyReward: number;
  dailyMaxAttempts: number;
  themePrices: Record<ThemeName, number>;
  /** Offer the (simulated) rewarded ad for revive and double rewards. */
  rewardedAds: boolean;
  dailyChallenge: boolean;
};
